<template>
  <a-drawer width="35%" :visible="visible" @close="onClose">
    <a-divider orientation="left">
      <b>{{ $t('回收报价') }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('单号')">
        <span>{{ current.orderNo }}</span>
      </a-form-model-item>
      <a-form-model-item :label="$t('联系人')">
        <span>{{ current.contactName }}（{{ current.contactPhone }}）</span>
      </a-form-model-item>
      <a-form-model-item :label="$t('物品描述')">
        <span>{{ current.categoryDesc }}</span>
      </a-form-model-item>
      <a-form-model-item :label="$t('报价金额')" prop="quoteAmount">
        <a-input-number v-model="form.quoteAmount" :min="0.01" :precision="2" style="width: 100%" :placeholder="$t('请输入')+$t('报价金额')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('报价备注')" prop="quoteRemark">
        <a-input v-model="form.quoteRemark" :maxLength="500" :placeholder="$t('请输入')+$t('报价备注')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="onClose">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { quoteRecycleOrder } from '@/api/recycle/order'

export default {
  name: 'QuoteForm',
  data () {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      submitLoading: false,
      visible: false,
      current: {},
      form: {
        id: null,
        quoteAmount: null,
        quoteRemark: null
      },
      rules: {
        quoteAmount: [{ required: true, message: '请输入报价金额', trigger: 'blur' }]
      }
    }
  },
  methods: {
    open (record) {
      this.current = record
      this.form = {
        id: record.id,
        quoteAmount: null,
        quoteRemark: null
      }
      this.visible = true
    },
    onClose () {
      this.visible = false
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          quoteRecycleOrder(this.form).then(response => {
            this.$message.success(this.$t('报价成功'), 3)
            this.visible = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
